<script setup>
import Bugsnag from "@bugsnag/js";
import { ElPopover } from "element-plus";
import { ref, onMounted } from "vue";
import { useLmsSettingsStore } from "@/stores/useLmsSettingsStore";
import { http } from "@/composable/httpService";
import { useRoute } from "vue-router";
import { computed } from "vue";

const route = useRoute();

const loading = ref(true);
const folders = ref([]);

const isResourceManager = computed(
  () => route.name === "filemanager" || route.name === "File Manager Folder"
);

const getFolders = () => {
  loading.value = true;
  http()
    .get("/v3/file-manager/folders")
    .then(({ data }) => {
      folders.value = data.splice(0, 20);
      loading.value = false;
    })
    .catch((error) => {
      loading.value = false;
      Bugsnag.notify(error);
    });
};

onMounted(() => {
  getFolders();
  const lmsSettingsStore = useLmsSettingsStore();
  if (lmsSettingsStore.isRestrictResourceManagement) {
    window.location.href = "/";
  }
});
</script>
<template>
  <div v-bind="$attrs" v-if="!loading">
    <el-popover
      v-if="folders.length"
      :width="220"
      popper-style="padding: 5px !important;z-index: 3000 !important; background-color: rgb(0 44 115)"
    >
      <template #reference>
        <router-link
          class="px-1 pt-1 text-sm w-full h-full flex justify-center items-center font-medium cursor-pointer"
          :class="{
            'text-white border-white border-b-2':
              isResourceManager,
            'hover:border-white border-b-2 border-transparent hover:text-white text-untitled-gray-400':
              !isResourceManager,
          }"
          to="/resource-manager"
        >
          Resource Manager
        </router-link>
      </template>
      <template #default>
        <div v-if="loading">
          <h3>Loading...</h3>
        </div>
        <div v-else class="w-full flex flex-col justify-start items-start">
          <div class="w-full" v-for="folder in folders" :key="folder.id">
            <a
              :href="'/resource-manager/' + folder.id"
              target="_blank"
              class="w-full px-2 py-2 text-sm flex justify-start items-start"
              :class="{
                'text-white':
                  route.fullPath === `/resource-manager/${folder.id}`,
                'hover:text-white text-untitled-gray-400':
                  route.fullPath !== `/resource-manager/${folder.id}`,
              }"
              >{{ folder.name }}</a
            >
          </div>
        </div>
      </template>
    </el-popover>
    <router-link
      v-if="!folders.length && !loading"
      class="px-1 pt-1 text-sm w-full h-full flex justify-center items-center font-medium cursor-pointer"
      :class="{
        'text-white border-white border-b-2':
          isResourceManager,
        'hover:border-white border-b-2 border-transparent hover:text-white text-untitled-gray-400':
          !isResourceManager,
      }"
      to="/resource-manager"
    >
      Resource Manager
    </router-link>
  </div>
</template>
<style lang="scss" scoped></style>
